//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
export default {
  name: 'DfHeader',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    button: {
      type: Object,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttonOn: this.value,
    };
  },
  computed: {
    isEmpty() {
      return /^\s*$/.test(this.text);
    },
  },
  methods: {
    change(value) {
      this.$emit('input', (this.buttonOn = value));
    },
  },
};
